const MIN_SEGMENTS_FOR_NESTED_MATCH = 2;

const countSegments = (path: string): number =>
  path.split('/').filter(Boolean).length;

export const getPathMatchLength = (pathname: string, path: string): number => {
  if (path === '/') return pathname === '/' ? 1 : 0;

  if (pathname === path || pathname.startsWith(`${path}/`)) return path.length;

  if (countSegments(path) < MIN_SEGMENTS_FOR_NESTED_MATCH) return 0;

  const idx = pathname.lastIndexOf(path);
  if (idx > 0) {
    const afterMatch = pathname[idx + path.length];
    if (afterMatch === undefined) return pathname.length;
    if (afterMatch === '/') return path.length;
  }

  return 0;
};
